import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { productWarehouseService } from 'features/inventory/warehouses/api/product-warehouse.service';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { laboratoryService } from 'shared/services';
import { Option, StatusOption } from 'shared/types/general';
import toast from 'shared/utils/toast';

interface AssignProductToWarehouseFormProps {
  productId: number;
  callback?: any;
}

export const AssignProductToWarehouseForm = ({
  productId,
  callback
}: AssignProductToWarehouseFormProps) => {
  const { t } = useTranslation();

  const [laboratories, setLaboratories] = useState<Option[]>([]);
  const [warehouses, setWarehouses] = useState<Option[]>([]);
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [laboratory, setLaboratory] = useState<Option | null>(null);
  const [warehouse, setWarehouse] = useState<Option | null>(null);

  useEffect(() => {
    laboratoryService.getAllBaseInformation().then((res) => {
      setLaboratories(res);
    });
    productWarehouseService.options().then((res) => {
      if (res.actions && res.actions.POST) {
        setStatusOptions(
          res.actions.POST.status.choices.map((item) => {
            return {
              ...item,
              display_name: t(`entities.product.status_options.${item.display_name}`)
            };
          })
        );
      }
    });
  }, []);

  useEffect(() => {
    if (laboratory) {
      warehouseService.getAllBaseInformation({ laboratory: laboratory.id }).then((res) => {
        setWarehouses(res);
      });
    }
    setWarehouse(null);
    setWarehouses([]);
  }, [laboratory]);

  const onSubmit = (e) => {
    warehouseService
      .assignProduct(
        warehouse.id,
        productId,
        +e.restock_threshold,
        +e.understock_threshold,
        +e.overstock_threshold,
        +e.status,
        e.notes
      )
      .then((res) => {
        toast.success('Magazzino aggiunto con successo.');
        if (callback) callback();
      });
  };

  return (
    <EnhancedForm onSubmit={onSubmit} autoStyleLayout columns={3}>
      {laboratories && (
        <IdentityField
          gridSpan={3}
          name="laboratory"
          component={AutocompleteAdapter}
          initValue={laboratory}
          defaultValue={laboratory}
          setValue={setLaboratory}
          options={laboratories}
          label={t('global.laboratory')}
        />
      )}
      {warehouses && (
        <IdentityField
          gridSpan={3}
          name="warehouse"
          component={AutocompleteAdapter}
          initValue={warehouse}
          defaultValue={warehouse}
          setValue={setWarehouse}
          options={warehouses}
          label={t('global.warehouse')}
          type="text"
        />
      )}
      {statusOptions && (
        <IdentityField
          gridSpan={3}
          name="status"
          label={t(`entities.product.status`)}
          component={AutocompleteAdapter}
          options={statusOptions}
          placeholder="Status"
          type="text"
          optionLabel="display_name"
          optionValue="value"
        />
      )}
      <IdentityField
        name="restock_threshold"
        label={t(`entities.product.restock_threshold`)}
        component={TextFieldAdapter}
        placeholder="Restock threshold"
        type="number"
      />
      <IdentityField
        name="understock_threshold"
        label={t(`entities.product.understock_threshold`)}
        component={TextFieldAdapter}
        placeholder="Understock threshold"
        type="number"
      />
      <IdentityField
        name="overstock_threshold"
        label={t(`entities.product.overstock_threshold`)}
        component={TextFieldAdapter}
        placeholder="Overstock threshold"
        type="number"
      />
      <IdentityField
        gridSpan={3}
        name="notes"
        component={TextFieldAdapter}
        label={t('global.notes')}
        type="text"
      />
    </EnhancedForm>
  );
};
